<template>
  <div class="App">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <ClientOnly>
      <noscript>
        <iframe :src="gtmIframeSrc"
  height="0" width="0" style="display:none;visibility:hidden"></iframe>
      </noscript>
    </ClientOnly>
  </div>
</template>

<script lang="ts">
import { useHead, useSeoMeta, defineNuxtComponent, useNuxtApp, useRuntimeConfig } from '#imports'
import type { Meta } from '@unhead/vue'
import { storeToRefs } from 'pinia'
import { DITokens} from '@/di'
import { onMounted, computed } from 'vue'
import { LOCAL_STORAGE_KEYS } from '@/const/localstorage'

export default defineNuxtComponent({
  components: {
  },
  setup() {
    const { $container } = useNuxtApp()
    const cartStore = $container.resolve(DITokens.CartStore)
    const { public: { GTM_ID } } = useRuntimeConfig()
    const { pokemonCart } = storeToRefs(cartStore)
    const meta: Meta[] = []

    const gtmIframeSrc = computed(() => `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`)

    useHead({
      meta,
      htmlAttrs: {
        lang: 'ja'
      }
    })
    useSeoMeta({
      ogType: 'website',
      ogImage: 'https://assets.ka-nabell.com/selling-web/sell-top/ogp.png',
      twitterCard: 'summary_large_image',
      ogLocale: 'ja_JP',
      googleSiteVerification: 'rQWpxIYGqUBrEDcCtlQ9GXpQW8gwCi1_97wqWvlkEIM'
    })


    // タブを跨いでカート状態を同期
    onMounted(() => {
      if (process.client) {
        window.addEventListener('storage', ({ key, newValue }) => {
          if (key === LOCAL_STORAGE_KEYS.POKEMON_CART) {
            const serialized = JSON.stringify(pokemonCart.value)
            const shouldReplace = typeof newValue === 'string' && serialized !== newValue
            if (shouldReplace) {
              pokemonCart.value = JSON.parse(newValue)
            }
          }
        })
      }
    })

    return {
      gtmIframeSrc
    }
  }
})
</script>

<style scoped>
.App {
  width: 100%;
}
</style>
